import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '@src/service/axios';
import { toast } from 'react-toastify';
import showLoader from '@components/loader';
import { setLoading } from '../../../../@core/components/skelton/store';
import queryString from 'query-string';

export const getTeam = createAsyncThunk('teamSlice/getTeam', async (_, { dispatch }) => {
    try {
        dispatch(setLoading(true));
        let response = await axios.get('/sales-team-by-tenant', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        dispatch(setLoading(false));
        return Promise.resolve(response.data);
    } catch (err) {
        dispatch(setLoading(false));
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const createTeam = createAsyncThunk('teamSlice/createTeam', async (data, { dispatch }) => {
    try {
        showLoader(true);
        let response = await axios.post('/sales-team', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Team Created Successfully.');
        dispatch(getTeam());
        showLoader(false);
        return Promise.resolve(response.data);
    } catch (err) {
        showLoader(false);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const updateTeam = createAsyncThunk('teamSlice/updateTeam', async (data, { dispatch }) => {
    try {
        showLoader(true);
        let response = await axios.put('/sales-team/' + data.id, data?.data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Team Updated Succesfully.');
        dispatch(getTeam());
        showLoader(false);
        return Promise.resolve(response.data);
    } catch (err) {
        showLoader(false);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});


export const deleteTeam = createAsyncThunk('teamSlice/deleteTeam', async (deleteId, { dispatch }) => {
    try {
        showLoader(true);
        let response = await axios.delete('/sales-team/' + deleteId, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Team deleted successfully.');
        dispatch(getTeam());
        showLoader(false);
        return Promise.resolve(response.data);
    } catch (err) {
        showLoader(false);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const getTeamOptions = createAsyncThunk('teamSlice/getTeamOptions', async (_, { dispatch }) => {
    try {
        dispatch(setLoading(true));

        let response = await axios.get('/sales-team-by-tenant/options', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        dispatch(setLoading(false));
        return Promise.resolve(response?.data?.data);
    } catch (err) {
        dispatch(setLoading(false));
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const getTeamOptionsByUser = createAsyncThunk('teamSlice/getTeamOptionsByUser', async (_, { dispatch }) => {
    try {
        dispatch(setLoading(true));
        let response = await axios.get('/sales-team-by-user/options', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        dispatch(setLoading(false));
        return Promise.resolve(response?.data?.data);
    } catch (err) {
        dispatch(setLoading(false));
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const getTeamMemberOptionsByUser = createAsyncThunk('teamSlice/getTeamMemberOptionsByUser', async (data, { dispatch }) => {
    try {
        const query = queryString.stringify(data);
        dispatch(setLoading(true));
        let response = await axios.get('/team-member-by-user/options?' + query, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        dispatch(setLoading(false));
        return Promise.resolve(response?.data?.data);
    } catch (err) {
        dispatch(setLoading(false));
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const getTeamOwners = createAsyncThunk('teamSlice/getTeamOwners', async (data, { dispatch }) => {
    try {
        const query = queryString.stringify(data);
        dispatch(setLoading(true));
        let response = await axios.get('/team-member-owners/options?' + query, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        dispatch(setLoading(false));
        return Promise.resolve(response?.data?.data);
    } catch (err) {
        dispatch(setLoading(false));
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const teamSlice = createSlice({
    name: 'teamSlice',
    initialState: {
        data: [],
        options: [],
        optionsByUser: [],
        memberOptionsByUser: [],
        ownersOptions: [],
        selectedTeam: {}
    },
    reducers: {
        handleSelectedTeam: (state, action) => {
            state.selectedTeam = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getTeam.fulfilled, (state, action) => {
            state.data = action?.payload;
            return;
        });
        builder.addCase(getTeamOptions.fulfilled, (state, action) => {
            state.options = action.payload;
            return;
        });
        builder.addCase(getTeamOptionsByUser.fulfilled, (state, action) => {
            state.optionsByUser = action.payload;
            return;
        });
        builder.addCase(getTeamMemberOptionsByUser.fulfilled, (state, action) => {
            state.memberOptionsByUser = action.payload;
            return;
        });
        builder.addCase(getTeamOwners.fulfilled, (state, action) => {
            state.ownersOptions = action.payload;
            return;
        });
    }
});

export const { handleSelectedTeam } = teamSlice.actions;

export default teamSlice.reducer;
